export const exportHeaders = [
    {
        label: "User ID",
        key: "user_id"
    },
    {
        label: "First Name",
        key: "first_name",
    },
    {
        label: "Last Name",
        key: "last_name",
    },
    {
        label: "Email",
        key: "email",
    },
    {
        label: "Status",
        key: "is_active"
    },
    {
        label: "Org name",
        key: "loyalty_organization_name"
    },
    {
        label: "Site Name",
        key: "loyalty_site_id"
    },
]